import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ProductPageView } from '../../components/salesProducts/ProductPageView';
import { ProductCapabilitiesPanel } from '../../components/salesProducts/ProductCapabilitiesPanel';
import { ProductMarketSegmentsPanel } from '../../components/salesProducts/ProductMarketSegmentsPanel';
import { ProductResourcesPanel } from '../../components/salesProducts/ProductResourcesPanel';
import { ProductBuyerPersonasPanel } from '../../components/salesProducts/ProductBuyerPersonasPanel';
import { ProductPricesPanel } from '../../components/salesProducts/ProductPricesPanel';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { SalesProduct, getSalesProduct } from '../../services/salesProductsApi';

export function ProductViewPage() {
  const { id = '' } = useParams();
  const [searchParams] = useSearchParams();
  const backPath = searchParams.get('from') === 'offer' ? '/sales/offer' : '/sales/products';
  const [product, setProduct] = useState<SalesProduct | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void (async () => {
      setLoading(true);
      try {
        setProduct(await getSalesProduct(id));
      } catch {
        toast.error('Falha ao carregar produto.');
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) {
    return <p className="text-secondary-500">Carregando...</p>;
  }

  if (!product) {
    return <p className="text-secondary-600">Produto não encontrado.</p>;
  }

  return (
    <PageShell>
      <PageHeader
        title={product.name}
        actions={
          <div className="flex flex-wrap items-center gap-3">
            <Link to={backPath} className="erp-link-back">
              ← Voltar para produtos
            </Link>
          </div>
        }
      />
      <div className="mb-6 space-y-6">
        <ProductCapabilitiesPanel productId={product.id} readOnly />
        <ProductMarketSegmentsPanel productId={product.id} readOnly />
        <ProductResourcesPanel productId={product.id} readOnly />
        <ProductBuyerPersonasPanel productId={product.id} readOnly />
        <ProductPricesPanel productId={product.id} readOnly />
      </div>
      <ProductPageView product={product} />
    </PageShell>
  );
}
